import React, { useState, useEffect } from "react";
import { DeleteCustomModal } from "@workspace/common";
import { useDispatch } from "react-redux";
import { truncate } from "@workspace/common/src/helpers/string_helper";
import "./LeftSideBarCustomViewCanvas.scss";
import SimpleBar from "simplebar-react";

const LeftSideBarCustomViewCanvas = ({
  customViews,
  editId,
  setEditId,
  handleDefaultViewSelection,
  handleSelectCustomView,
  handleDeleteCustomView,
}) => {
  const dispatch = useDispatch();
  const [defaultViewSelected, setDefaultViewSelected] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deletingCustomViewId, setDeletingCustomViewId] = useState(null);

  useEffect(() => {
    if (customViews != null && customViews.length == 0) {
      setDefaultViewSelected(true);
      setEditId(null);
    }
    if (customViews != null && customViews.length > 0) {
      const selectedView = customViews.find((item) => item?.selected);
      if (selectedView) {
        setDefaultViewSelected(false);
      } else {
        setDefaultViewSelected(true);
      }
    }
  }, [customViews]);

  const selectedStyle = (isSelected) => {
    return {
      border: isSelected ? "1px solid #3348FF" : "1px solid transparent",
      backgroundColor: isSelected ? "#E0EDFF" : "transparent",
      borderRadius: "5px",
    };
  };

  const customViewStyle = (isSelected) => {
    return {
      border: isSelected ? "1px solid #3348FF" : "1px solid transparent",
      backgroundColor: isSelected ? "#E0EDFF" : "#F6F7F9",
      borderRadius: "5px",
    };
  };

  const isSelected = false;

  const handleCreateNewView = () => {
    setEditId(null);
  };

  const handleDeleteButtonClick = (id) => {
    setDeleteModalOpen(true);
    setDeletingCustomViewId(id);
  };

  const handleDeleteCustomViewConfirm = (id) => {
    const customView = customViews.find((view) => view?.id === id);
    handleDeleteCustomView(id);
    // dispatch(deleteReportCustomView({ id: id, type: "Job Universal Report" }));
    setDeleteModalOpen(false);
    setDeletingCustomViewId(null);
    if (customView?.selected) {
      handleDefaultViewSelection(false);
    }
    setEditId(null);
  };

  return (
    <div class="w-100 pt-2 px-1">
      <div className="cv-option" style={{ ...selectedStyle(editId == null) }}>
        <span onClick={handleCreateNewView}>+ Create Custom View</span>
      </div>
      <div>
        <div className="cv-option" onClick={handleDefaultViewSelection}>
          <span>+ Enable Default View</span>
          {defaultViewSelected && <i className="ri-check-fill"></i>}
        </div>
      </div>
      <hr className="my-3" />
      <div className="fw-semibold mb-2">My Custom View</div>
      {customViews?.length > 0 && (
        <div className="custom-view-scroll">
          {customViews?.map((item, index) => (
            <div
              key={index}
              className="cv-option-created"
              style={{
                ...customViewStyle(item?.id === editId),
              }}
            >
              <span
                className="flex-grow-1"
                style={{ fontSize: "12px" }}
                onClick={() => {
                  setEditId(item?.id);
                }}
              >
                {truncate(item?.name, 20)}
              </span>
              <span className="d-flex align-items-center gap-3">
                {item?.selected && <i className="ri-check-fill"></i>}
                <i
                  className="ri-eye-line cursor-pointer"
                  onClick={() => handleSelectCustomView(item?.id)}
                ></i>
                <i
                  className="ri-delete-bin-6-line cursor-pointer"
                  onClick={() => handleDeleteButtonClick(item?.id)}
                ></i>
              </span>
            </div>
          ))}
        </div>
      )}
      <DeleteCustomModal
        isOpen={deleteModalOpen}
        setIsOpen={setDeleteModalOpen}
        confirmDelete={() =>
          handleDeleteCustomViewConfirm(deletingCustomViewId)
        }
        header="Delete Custom View Confirmation"
        deleteText={`Are you sure you want to delete this custom view?`}
        confirmButtonText="Delete"
        isLoading={false}
      />
    </div>
  );
};

export default LeftSideBarCustomViewCanvas;
